import React, { Component }  from 'react'
import { Icon, Button, Confirm } from 'semantic-ui-react'

class StudentsDelete extends Component {
  state = { open: false }

  show = () => this.setState({ open: true })
  handleConfirm = () => {
    this.props.handleDelete(this.props.studentId)
    this.setState({ open: false })
  }
  handleCancel = () => this.setState({ open: false })

  render() {
    return (
      <span>
        <Button icon size='tiny' onClick={this.show}>
          <Icon name='trash' />
        </Button>
        <Confirm
          open={this.state.open}
          header=''
          content={`Are you sure you want to delete student: ${this.props.studentName}?`}
          onCancel={this.handleCancel}
          onConfirm={this.handleConfirm}
        />
    </span>
    )
  }
};

export default StudentsDelete;
